import { seoConfig } from './seoConfig';

export const canonicalBase = (
  process.env.REACT_APP_SITE_URL ||
  seoConfig?.company?.website ||
  'https://initx.online'
).replace(/\/+$/, '');

const normalizePath = (pathname) => {
  if (!pathname || pathname === '/') {
    return '/';
  }
  return pathname.endsWith('/') ? pathname.replace(/\/+$/, '') : pathname;
};

export const buildCanonicalUrl = (incomingUrl, { includeSearch = false } = {}) => {
  try {
    if (incomingUrl) {
      const url = new URL(incomingUrl, canonicalBase);
      const normalizedPath = normalizePath(url.pathname);
      const canonical = normalizedPath === '/' ? `${canonicalBase}/` : `${canonicalBase}${normalizedPath}`;
      return includeSearch && url.search ? `${canonical}${url.search}` : canonical;
    }
  } catch {
    // Fall back to window-based resolution below.
  }

  if (typeof window === 'undefined') {
    return `${canonicalBase}/`;
  }

  const normalizedPath = normalizePath(window.location?.pathname);
  return normalizedPath === '/' ? `${canonicalBase}/` : `${canonicalBase}${normalizedPath}`;
};

export default buildCanonicalUrl;
